import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import { observer, inject } from 'mobx-react';

@observer
class ComparisonSavingsComponent extends React.Component {
  render() {
    const { comparedProviderData } = this.props.ComparisonFormData;
    // const { allLabels } = this.props.ProviderLabelData;
    const { savings } = comparedProviderData;
    // const cheapestProvider = _.min(comparedProviderData.labels, label => label.totalInterestCosts);
    // const cheapestProviderName = allLabels.find(x => x.id === cheapestProvider.labelId).providerName;

    // TODO: Fix this to show the cheapest provider
    const totalSavingsMessage = savings === 0 ?
       'De totale rentelasten zijn gelijk.' : 'Uw totale besparing is';
    const totalSavings = savings !== 0 && numeral(savings).format('$ 0,00.');

    return (
      <div className="comparison-container__savings">
        <span className="comparison-container__cheapest-provider float-left bold">
          {totalSavingsMessage}
        </span>
        <span className="comparison-container__savings__savings float-right">
          {totalSavings}
        </span>
      </div>
    );
  }
}

ComparisonSavingsComponent.propTypes = {
  ComparisonFormData: PropTypes.shape({
    comparedProviderData: PropTypes.shape({}),
  }),
  ProviderLabelData: PropTypes.shape({
    allLabels: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({})),
    ]),
  }),
};

ComparisonSavingsComponent.defaultProps = {
  ComparisonFormData: {
    comparedProviderData: {},
  },
  ProviderLabelData: {
    allLabels: [],
  },
};

export default inject('ComparisonFormData', 'ProviderLabelData')(ComparisonSavingsComponent);
